// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editcatelogue_containers {
  overflow: hidden;
  height: 100vh;
}
.editcatelogue_containers .editcatelogue_container {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.editcatelogue_containers .third_para {
  margin: 1rem 1.6rem;
}
.editcatelogue_containers .editcateloguemain {
  width: 100%;
  background: #ffffff;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 84vh;
}
.editcatelogue_containers .tvsparts_text {
  font-family: "Nunito";
  font-size: 0.75rem;
  font-weight: 500;
  display: flex;
  padding: 0rem 1rem;
  align-items: center;
}
.editcatelogue_containers .editcateloguebuttons_container {
  display: flex;
  justify-content: space-between;
  width: 96%;
  margin: 1rem;
}
.editcatelogue_containers .partcateloguebutton {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}
.editcatelogue_containers .part_catelogue_buttons {
  background: #e4ecf7;
  border-radius: 5px;
  font-family: Nunito;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
}
.editcatelogue_containers .edit_catelogue_addbuttons {
  border-radius: 5px;
  font-family: Nunito;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  color: #ffffff;
}
.editcatelogue_containers .tabledata {
  display: flex;
  width: 96%;
  margin: 1rem;
}
.editcatelogue_containers .table {
  border-collapse: collapse;
  width: 100%;
  background: #ffffff;
  border: 0.5px solid #999797;
}
.editcatelogue_containers .tablesth {
  color: white;
  text-align: left;
  padding: 14px 12px;
  background-color: #f5f5f5;
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  background: #0c3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px -2px 0px 0px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #ffffff;
}
.editcatelogue_containers .tabletd {
  text-align: left;
  padding: 22px 5px;
  font-style: normal;
  font-weight: 400;
  font-size: 16.4px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #070707;
  border-top: 0.5px solid #999797;
}
.editcatelogue_containers .tabletd_view {
  text-align: left;
  padding: 22px 5px;
  text-align: left;
  padding: 14px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  text-decoration-line: underline;
  color: #0c3688;
  border-top: 0.5px solid #999797;
  cursor: pointer;
}
.editcatelogue_containers .footer_div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.editcatelogue_containers .header_border {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
}
.editcatelogue_containers .header_border > img {
  margin: 0.9rem 1rem;
}
.editcatelogue_containers .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 1rem;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}
.editcatelogue_containers .Addnew_text {
  font-family: "Nunito";
  font-size: 20px;
  font-weight: 600;
}
.editcatelogue_containers .editcatelogue_second_para {
  margin: 1rem;
  display: flex;
  flex-direction: column;
}
.editcatelogue_containers .editcatelogue_second_para > img {
  width: 100px;
  height: 100px;
}
.editcatelogue_containers .editcatelogue_second_para > span {
  font-family: Nunito;
  font-size: 14px;
  font-weight: 700;
  text-decoration: underline;
  color: #0c3688;
  margin: 0rem 1.6rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/EditCatelogue/editcatelogue.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;AACF;AAAE;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAEJ;AAAA;EACE,mBAAA;AAEF;AACE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AACJ;AAEE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;AADJ;AAKE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAHJ;AAKE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAHJ;AAKE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mEAAA;EACA,cAAA;AAHJ;AAKE;EACE,aAAA;EACA,UAAA;EACA,YAAA;AAHJ;AAKE;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;AAHJ;AAKE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,8CAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAHJ;AAKE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,+BAAA;AAHJ;AAKE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,eAAA;AAHJ;AAKE;EACE,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AAHJ;AAKE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAKE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAKE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;AAHJ;AAKE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAHJ;AAKE;EACE,YAAA;EACA,aAAA;AAHJ;AAKE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;EACA,mBAAA;AAHJ","sourcesContent":[".editcatelogue_containers {\n  overflow: hidden;\n  height: 100vh;\n  .editcatelogue_container {\n    width: 100%;\n    display: flex;\n    overflow: hidden;\n  }\n.third_para{\n  margin: 1rem 1.6rem;\n}\n\n  .editcateloguemain {\n    width: 100%;\n    background: #ffffff;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    height: 84vh;\n  }\n \n  .tvsparts_text {\n    font-family: \"Nunito\";\n    font-size: 0.75rem;\n    font-weight: 500;\n    display: flex;\n    padding: 0rem 1rem;\n    align-items: center;\n  }\n\n  .editcateloguebuttons_container {\n    display: flex;\n    justify-content: space-between;\n    width: 96%;\n    margin: 1rem;\n  }\n  \n\n  .partcateloguebutton {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n  .part_catelogue_buttons {\n    background: #e4ecf7;\n    border-radius: 5px;\n    font-family: Nunito;\n    font-size: 1rem;\n    font-weight: 600;\n    padding: 0.4rem 1rem;\n  }\n  .edit_catelogue_addbuttons {\n    border-radius: 5px;\n    font-family: Nunito;\n    font-size: 1rem;\n    font-weight: 600;\n    padding: 0.4rem 1rem;\n    background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n    color: #ffffff;\n  }\n  .tabledata {\n    display: flex;\n    width: 96%;\n    margin: 1rem;\n  }\n  .table {\n    border-collapse: collapse;\n    width: 100%;\n    background: #ffffff;\n    border: 0.5px solid #999797;\n  }\n  .tablesth {\n    color: white;\n    text-align: left;\n    padding: 14px 12px;\n    background-color: #f5f5f5;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 1rem;\n    background: #0c3688;\n    box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n    border-radius: 5px -2px 0px 0px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 1rem;\n    color: #ffffff;\n  }\n  .tabletd {\n    text-align: left;\n    padding: 22px 5px;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16.4px;\n    text-align: left;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #070707;\n    border-top: 0.5px solid #999797;\n  }\n  .tabletd_view {\n    text-align: left;\n    padding: 22px 5px;\n    text-align: left;\n    padding: 14px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    text-decoration-line: underline;\n    color: #0c3688;\n    border-top: 0.5px solid #999797;\n    cursor: pointer;\n  }\n  .footer_div {\n    margin-top: 1rem;\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n  }\n  .header_border {\n    background: #c0c8da;\n    height: 2.4rem;\n    border: 1px solid #c0c8da;\n  }\n  .header_border > img {\n    margin: 0.9rem 1rem;\n  }\n  .header_border > span {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 1rem;\n    display: flex;\n    align-items: center;\n    letter-spacing: -0.28px;\n    margin: 0.7rem 1rem;\n  }\n  .Addnew_text {\n    font-family: \"Nunito\";\n    font-size: 20px;\n    font-weight: 600;\n  }\n  .editcatelogue_second_para {\n    margin: 1rem;\n    display: flex;\n    flex-direction: column;\n  }\n  .editcatelogue_second_para> img{\n    width: 100px;\n    height: 100px;\n  }\n  .editcatelogue_second_para > span {\n    font-family: Nunito;\n    font-size: 14px;\n    font-weight: 700;\n    text-decoration: underline;\n    color: #0c3688;\n    margin: 0rem 1.6rem;\n    \n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
